const PageLoading = () => {
    return ( 
        <div className="container-fluid">
               <div className="d-flex justify-content-center">
                         <div className="spinner-border text-primary" role="status">
                           
                        </div>
               </div>
                       
                  
        </div>
     );
}
 
export default PageLoading;